import { cloneObject } from "./array-helpers";

export class ClipboardData<T> {
  private clipboardData: T | undefined = undefined;
  public setData(data: T) {
    this.clipboardData = cloneObject(data);
  }
  public getData(): T | undefined {
    return this.clipboardData;
  }
  public clear() {
    this.clipboardData = undefined;
  }
  public hasData(): boolean {
    return this.clipboardData !== undefined;
  }
}
